import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LegalContent from "@/components/LegalContent";
import { useLanguage } from "@/context/LanguageContext";
import { content } from "@/content/fitswag";

export default function LegalPage({ type }) {
  const { lang } = useLanguage();
  const data = content[lang].legal[type];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <LegalContent id={type} data={data} standalone />
      </main>
      <Footer />
    </>
  );
}
